import axios from 'axios';
import { ThumbtackStorage } from './QGDStorage';

export const FetchThumbtackListings = async (zip_code, projects_list) => {
    const currentDomain = window.location.hostname;
    const prodDomains = ['getquoll'];
    const isProd = prodDomains.some(domain => currentDomain.includes(domain));
    
    // Initialize storage
    await ThumbtackStorage.init();
    
    // Create array of composite keys to check
    const keysToCheck = projects_list.map(project_id => `${zip_code}_${project_id}`);
    console.log('Keys to check:', keysToCheck);
    
    // Get existing listings
    const existingListings = await Promise.all(
        keysToCheck.map(async key => {
            const [zip, projectId] = key.split('_');
            return await ThumbtackStorage.getListing(zip, projectId);
        })
    );
    // console.log('Existing listings found:', existingListings);

    // Filter out projects that already have listings
    const idsNotInFilteredListings = projects_list.filter((project_id, index) => 
        !existingListings[index]
    );
    // console.log('Projects needing listings:', idsNotInFilteredListings);
    
    // Return early if no new listings needed
    if (idsNotInFilteredListings.length === 0) {
        // console.log('No new listings needed, returning early');
        return true;
    }

    // Create the body for the POST request
    const body = {
        zip_code: zip_code,
        projects: idsNotInFilteredListings,
        is_production: isProd
    };
    // console.log('Request body:', body);

    try {
        // console.log('Making API request...');
        const response = await axios.post(
            `${import.meta.env.VITE_API_BASE_URL}/get-thumbtack-listings`,
            body,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        
        // console.log('API response:', response);

        if (response.data && Array.isArray(response.data)) {
            // console.log('Storing new listings:', response.data);
            // Store each listing using the ThumbtackStorage service
            await ThumbtackStorage.setBulkListings(
                response.data.map(listing => ({
                    ...listing,
                    zip_code: zip_code // Ensure zip_code is included
                }))
            );
        } else {
            console.warn('Response data is not in expected format:', response.data);
        }
        
        return true;
    } catch (error) {
        console.error('Error in FetchThumbtackListings:', error);
        if (error.response) {
            console.error('Error response data:', error.response.data);
            console.error('Error response status:', error.response.status);
            console.error('Error response headers:', error.response.headers);
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};
